module.exports = __webpack_public_path__ + "img/behaviour-lab-test-logo.696b36bb.png";